import React from 'react';
export function Footer() {
  return <footer className="border-t border-charcoal-line bg-charcoal px-4 py-8 text-center" data-id="element-127">
      <div className="mx-auto max-w-4xl" data-id="element-128">
        <p className="text-sm font-medium text-gold-light" data-id="element-129">
          © {new Date().getFullYear()} Dance Fitness Instructor Pro™ — All
          Rights Reserved.
        </p>
        <p className="mx-auto mt-4 max-w-3xl text-xs leading-relaxed text-zinc-600" data-id="element-130">
          The content on this page is for educational and informational purposes
          only and does not replace professional fitness certification or
          medical advice. Always consult a qualified health professional before
          beginning intensive physical exercise and follow appropriate safety
          guidelines when teaching groups with special physical needs.
        </p>
        <p className="mt-4 text-xs text-zinc-500" data-id="element-131">
          Terms & Conditions · Privacy Policy · Contact
        </p>
      </div>
    </footer>;
}